import { Link } from "react-router-dom";
import { Play } from "lucide-react";

/**
 * StoryCard that works off real API story shape.
 * Variant "compact" (default, 3:4) — used on homepage + stories list.
 */
export default function StoryCardApi({ story, index = 0 }) {
  const {
    slug,
    name,
    city,
    industry,
    short_quote,
    portrait_url,
    season,
  } = story;

  return (
    <Link
      to={`/stories/${slug}`}
      data-testid={`story-card-${slug}`}
      className="group relative block overflow-hidden bg-charcoal/5 rounded-sm"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={portrait_url}
          alt={`${name}, ${industry} en ${city}`}
          loading="lazy"
          decoding="async"
          width="1024"
          height="1536"
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-[900ms] [transition-timing-function:cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal/85 via-charcoal/20 to-transparent" />

        {season && (
          <div className="absolute top-4 left-4 bg-charcoal/80 backdrop-blur-sm text-cream text-[10px] uppercase tracking-[0.2em] px-3 py-1.5 rounded-full">
            {season}
          </div>
        )}
        <div className="absolute top-4 right-4 inline-flex items-center gap-1.5 bg-terracotta/90 text-cream text-[10px] uppercase tracking-[0.15em] px-2.5 py-1.5 rounded-full">
          <Play className="h-2.5 w-2.5 fill-current" />
          Doc
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6 text-cream">
          <p className="text-[10px] uppercase tracking-[0.25em] text-gold mb-2">
            {city} · {industry}
          </p>
          <h3 className="font-serif text-2xl md:text-[28px] leading-tight mb-3 font-light">
            {name}
          </h3>
          {short_quote && (
            <p className="font-serif italic text-sm md:text-base text-cream/85 line-clamp-2">
              “{short_quote}”
            </p>
          )}
        </div>
      </div>
    </Link>
  );
}
